/** Shared LeadStatus constants — split out of BeneficiaryDetailDrawer.tsx
 * (2026-09-17) so the status changer can live in more than one place
 * (the drawer's own selector, and the compact card's inline one) without
 * either file importing a component module just to get a constant, and
 * without tripping the "fast refresh only works when a file only
 * exports components" lint rule.
 */
import type { LeadStatus } from "@/lib/types";

export const STATUS_VALUES: LeadStatus[] = [
  "new",
  "contacted",
  "contact_failed",
  "scheduled",
  "confirmed",
  "session_done",
  "no_show",
  "declined",
];

/** Statuses that require an outcome reason before they apply — gated
 * behind the drawer's own reason field, never half-applied elsewhere. */
export const DECLINED_STATUSES = new Set<LeadStatus>(["declined"]);

export const STATUS_STYLES: Record<LeadStatus, string> = {
  new: "bg-slate-700/40 text-nb-text-2 border-slate-600/50",
  contacted: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  /* Amber-warning, not danger: nothing is wrong with the beneficiary,
     the send failed. Danger red is reserved for `declined`, which is
     their actual answer. */
  contact_failed: "bg-orange-500/15 text-orange-300 border-orange-500/30",
  scheduled: "bg-nb-mint/15 text-nb-mint border-nb-mint/30",
  confirmed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  session_done: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
  no_show: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  declined: "bg-cvp-danger/15 text-cvp-danger border-cvp-danger/30",
};
